module.exports = __webpack_public_path__ + "img/コンピュータのしくみII_1_10_4.bdc7edbd.jpg";